import { render, staticRenderFns } from "./purchaseSuccess.vue?vue&type=template&id=368344b7&"
import script from "./purchaseSuccess.vue?vue&type=script&lang=js&"
export * from "./purchaseSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports